import {Filter} from '../contracts/report-definition.types';

/** The definition's filter as report-service should receive it: without the conditions that carry
 * no value yet.
 *
 * A condition is born valueless - `addCondition` writes `values: []` and the reader picks after -
 * and until they pick, the condition says nothing. report-service refuses to guess what nothing
 * means, and rightly so: an equality over no values matches no row while a negation over no values
 * matches every row, so it answers `400 No value given to compare <FIELD> against` rather than
 * returning a plausible report built from a condition that said nothing.
 *
 * That refusal is only reachable for the resolver-side project-status fields, which
 * `ProjectStatusRowFilter` evaluates itself; service-company's wire-side query builder quietly
 * emits no predicate for the same shape, which is why adding an empty Client condition has always
 * been harmless while adding an empty Progress one killed the whole report until a band was picked.
 * Sending the same request either way is the point - the client should not depend on which engine
 * happens to be forgiving.
 *
 * Dropped on the way OUT only. The condition stays in the definition, so its tile stays on screen
 * with its prompt, which is what tells the reader there is a choice still to make.
 *
 * Returns the original object when there is nothing to drop, so an unchanged filter keeps its
 * identity and cannot spuriously retrigger anything memoised on it. */
export function withoutValuelessConditions(filter: Filter): Filter {
	const kept = filter.filterConditions.filter(condition => condition.values.length > 0);
	if (kept.length === filter.filterConditions.length) {
		return filter;
	}
	return {...filter, filterConditions: kept};
}
